import Flickity from 'flickity';

const carousels = [...document.querySelectorAll('.js-team-mobile-carousel')];

carousels.forEach(carousel => {
    var flkty = new Flickity(carousel, {
        watchCSS: true,
        cellAlign: 'left',
        contain: true,
        cellSelector: '.js-team-mobile-carousel__team'
    });
})
